import type { SoldService } from '../types/agreements.types';

export const linkedServiceNames = (services: SoldService[]): Map<string, string> =>
    new Map(services.map((service) => [service.id, service.name]));
